// extracted by css-extract-rspack-plugin
export default {"headerHeight":"66px","spaceXSmall":"8px","spaceNone":"0px","size60":"60px","sizeFluid":"100%","elevationToast":"60","header":"header__header___doDyx","logo":"header__logo___KNw1W"};